import { BaseService } from './BaseService';

export class BannerService extends BaseService {

  async getBanners(){
    try {
      return this.http('app/banners', 'get', {});
    } catch (error) {
      
      return {
        ok: false,
        message: error.message
      }
    }
  }
}